/**
 *
 * AppBar
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import styled from "styled-components";
import injectReducer from "utils/injectReducer";
//logo here
import Logo from "images/avadent_logo.png";
import { getUser } from "utils/userStorage";
import Hamburger from "components/Hamburger/Hamburger";
import Person from "images/UserIcon";
import LocationOn from "images/LocationIcon";
import { makeSelectSinglePractice } from "containers/App/selectors";
import history from "utils/history";
import { isIE, isMobile } from "react-device-detect";
import reducer from "./reducer";
import { makeSelectPractice } from "../PracticePage/selectors";
import { selectPracticeAction } from "../PracticePage/actions";
import { FormattedMessage } from "react-intl";
import messages from "../AdminPage/messages";
import MobileAdminAppBar from "components/MobileAdminAppBar";

export const AppBarHeight = "4rem";

export class AppBar extends Component {
  static propTypes = {
    practice: PropTypes.any,
    hideDetails: PropTypes.bool,
    hideHamburger: PropTypes.bool,
    hamburgerFilter: PropTypes.arrayOf(PropTypes.string),
    onLogoClicked: PropTypes.func.isRequired,
    selectPractice: PropTypes.func,
    isAdmin: PropTypes.bool,
  };

  isLocationClickable() {
    return !!this.props.practice;
  }

  handleLocationClicked = () => {
    if (this.isLocationClickable()) {
      history.push("/dashboard/practice");
    }
  };

  renderPractice(clickable) {
    const { practice } = this.props;
    window.selectedPractice = practice
    return (
      <>
        <Row clickable={clickable} onClick={this.handleLocationClicked}>
          <LocationCircle>
            <LocationOn />
          </LocationCircle>
        </Row>
        <Row clickable={clickable} onClick={this.handleLocationClicked}>
          <Span>{practice.name}</Span>
        </Row>
      </>
    );
  }

  renderUser(clickable) {
    const user = getUser();
    if (!user) return null;

    return (
      <Row clickable={clickable} onClick={this.handleLocationClicked}>
        <LocationCircle>
          <Person />
        </LocationCircle>
        <RowContent>
          <SpanName data-cy="loggedInUser">{user.firstName}</SpanName>{" "}
          <SpanName>{user.lastName}</SpanName>
        </RowContent>
      </Row>
    );
  }

  render() {
    const { isAdmin, hamburgerFilter, selectPractice } = this.props;
    const isLocationClickable = this.isLocationClickable();

    if (isAdmin && isMobile) {
      return (
        <MobileAdminAppBar
          user={getUser()}
          hamburgerFilter={hamburgerFilter}
          selectPractice={selectPractice}
        />
      );
    }

    return (
      <Wrapper isAdmin={isAdmin}>
        {isAdmin && (
          <AdminMessage data-cy="adminPanel">
            <FormattedMessage {...messages.header} />
          </AdminMessage>
        )}
        <LogoRow
          isAdmin={isAdmin}
          clickable
          onClick={this.props.onLogoClicked}
          logo
          isIE={isIE}
          data-cy="iconRefrezh"
        >
          {/* logo here */}
          <img src={Logo} alt="Refrezh logo" style={{ height: "28px" }} />
        </LogoRow>
        {!this.props.hideDetails && (
          <Row>
            <div>{this.renderUser(isLocationClickable)}</div>
            {!isAdmin && (
              <Practice id="practiceButton">
                {this.props.practice &&
                  this.renderPractice(isLocationClickable)}
              </Practice>
            )}
            {!this.props.hideHamburger && (
              <Hamburger
                filter={this.props.hamburgerFilter}
                selectPractice={this.props.selectPractice}
                isAdminPage={this.props.isAdmin}
              />
            )}
          </Row>
        )}
      </Wrapper>
    );
  }
}

const AdminMessage = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #253d91;
  display: flex;
  margin-left: 2rem;
  white-space: nowrap;
`;
const Practice = styled.div`
  display: flex;
`;

const Span = styled.span`
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SpanName = styled.span`
  ${({ theme }) => theme.phone`
   display: none;
 `};
`;

const RowContent = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LocationCircle = styled.div`
  margin-right: ${({ theme }) => theme.margin}rem;
  margin-left: ${({ theme }) => theme.margin}rem;
  margin-top: 3px;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
  }
`;

const Row = styled.div`
  display: flex;
  ${({ clickable }) => clickable && "cursor: pointer"};

  ${({ logo }) => logo && isIE && "width: 130px"};
`;

const LogoRow = styled(Row)`
  padding-left: 1rem;
  ${({ theme }) => theme.tabletLandscapeUp`
    padding-left: 0;
  `};
`;

const Wrapper = styled.div`
  background-color: white;
  display: flex;
  height: ${AppBarHeight};
  line-height: 2rem;
  box-sizing: border-box;
  padding-top: ${({ theme }) => theme.padding}rem;
  padding-bottom: ${({ theme }) => theme.padding}rem;
  justify-content: space-between;
  position: relative;

  ${({ theme }) => theme.tabletLandscapeUp`


      padding-left: ${props => (props.isAdmin ? "0" : "10rem")};
      padding-right: 10rem;
  `};

  ${({ theme }) => theme.phone`
        border-bottom: 1px solid #eee;
  `};
`;

const mapStateToProps = createStructuredSelector({
  practice: makeSelectPractice(),
  hidePracticeSelect: makeSelectSinglePractice(),
});

function mapDispatchToProps(dispatch) {
  return {
    selectPractice: practice => dispatch(selectPracticeAction(practice)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "appBar", reducer });

export default compose(
  withReducer,
  withConnect,
)(AppBar);
